<template>
  <div class="pa-form-fields pa-kin-form">
    <p class="section-intro">Add the person to contact in case of emergency.</p>
    <div class="form-row">
      <div class="input-group">
        <label class="input-label">Name <span class="req">*</span></label>
        <v-text-field
          :value="form.kinName"
          outlined
          dense
          hide-details="auto"
          class="custom-input"
          :error-messages="errors.kinName"
          @input="update('kinName', $event)"
          @blur="touch('kinName')"
        />
      </div>
      <div class="input-group">
        <label class="input-label">ID number <span class="req">*</span></label>
        <v-text-field
          :value="form.kinId"
          outlined
          dense
          hide-details="auto"
          class="custom-input"
          maxlength="9"
          :error-messages="errors.kinId"
          @input="onKinIdInput"
          @blur="touch('kinId')"
        />
      </div>
    </div>
    <div class="form-row">
      <div class="input-group">
        <label class="input-label">Contact <span class="req">*</span></label>
        <v-text-field
          :value="form.kinContact"
          outlined
          dense
          hide-details="auto"
          class="custom-input"
          maxlength="10"
          placeholder="07XXXXXXXX"
          :error-messages="errors.kinContact"
          @input="onKinContactInput"
          @blur="touch('kinContact')"
        />
      </div>
      <div class="input-group">
        <label class="input-label">Relationship <span class="req">*</span></label>
        <v-text-field
          :value="form.kinRelation"
          outlined
          dense
          hide-details="auto"
          class="custom-input"
          placeholder="e.g. Mother"
          :error-messages="errors.kinRelation"
          @input="update('kinRelation', $event)"
          @blur="touch('kinRelation')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { validateNationalId, validatePhone } from '@/utils/paValidation';

export default {
  name: 'PaNextOfKinForm',
  props: {
    form: { type: Object, required: true },
  },
  data() {
    return { touched: {}, errors: {} };
  },
  methods: {
    update(field, value) {
      this.$emit('update:form', { ...this.form, [field]: value });
      if (this.touched[field]) this.validateField(field);
    },
    onKinIdInput(v) {
      this.update('kinId', String(v || '').replace(/\D/g, '').slice(0, 9));
    },
    onKinContactInput(v) {
      this.update('kinContact', String(v || '').replace(/\D/g, '').slice(0, 10));
    },
    touch(field) {
      this.$set(this.touched, field, true);
      this.validateField(field);
    },
    validateField(field) {
      const e = { ...this.errors };
      const f = this.form;
      switch (field) {
        case 'kinName':
          e.kinName = f.kinName?.trim() ? '' : 'Name is required';
          break;
        case 'kinId': {
          const id = validateNationalId(f.kinId);
          e.kinId = id.valid ? '' : id.message;
          break;
        }
        case 'kinContact': {
          const p = validatePhone(f.kinContact);
          e.kinContact = p.valid ? '' : p.message;
          break;
        }
        case 'kinRelation':
          e.kinRelation = f.kinRelation?.trim() ? '' : 'Relationship is required';
          break;
        default:
          break;
      }
      this.errors = e;
    },
    validateAll() {
      ['kinName', 'kinId', 'kinContact', 'kinRelation'].forEach((f) => {
        this.$set(this.touched, f, true);
        this.validateField(f);
      });
      return !Object.values(this.errors).some((msg) => msg);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/agent-pa-form.scss';

.pa-kin-form {
  border: 1px solid #E2E8F0;
  border-radius: 10px;
  background: #F8FAFC;
  padding: 14px;
}

.section-intro {
  margin: 0 0 12px;
  font-size: 0.82rem;
  color: #64748B;
}

@media (max-width: 960px) {
  .pa-kin-form {
    padding: 12px;
  }
}
</style>
